<template>
  <div>
    <template v-if="currentUser.role">
      <Offers v-if="isCandidate"/>
      <DashboardManager v-else/>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { checkRoleCandidate } from '@/helpers/roles'
import DashboardManager from '@/components/dashboard/Manager'
import Offers from '@/components/offers/Offers'

export default {
  name: "DashboardPage",
  components: {
    DashboardManager,
    Offers,
  },
  computed: {
    ...mapGetters({
      currentUser: 'auth/currentUser'
    }),
    isCandidate(){
      return checkRoleCandidate(this.currentUser.role)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/DashboardPage.vue